import { getFeatureFlagValue } from '@citrite/feature-flags';
import { PadlockSquare } from '@sharefiledev/icons';
import { FeatureFlag } from '../../../featureFlags';
import { SelectFieldProps } from '../Fields';
import { StyledTag } from '../Fields.styled';

export const SingleSelectText = (props: SelectFieldProps) => {
	const { attributes, fieldValue } = props;
	const selectConfig = attributes.enumConfig;
	const activeStatus = fieldValue;
	const isClosedProjectFFEnabled =
		getFeatureFlagValue(FeatureFlag.EnableResourceFreezing) ?? false;
	const getBadge = (badgeType: string, children: React.ReactNode) => {
		if (badgeType) {
			return (
				<StyledTag bordered={false} badgeType={badgeType}>
					{props?.locked && isClosedProjectFFEnabled && (
						<span style={{ marginRight: '2px' }}>
							<PadlockSquare data-testid="badge-locked-icon" />
						</span>
					)}
					{children}
				</StyledTag>
			);
		}
		return null;
	};
	const currentSelectConfig = selectConfig![activeStatus];

	if (!currentSelectConfig) {
		return null;
	}

	return <>{getBadge(currentSelectConfig.badgeType, currentSelectConfig.displayName)}</>;
};
